import { render, staticRenderFns } from "./reels.vue?vue&type=template&id=81bd2fea&"
import script from "./reels.vue?vue&type=script&lang=js&"
export * from "./reels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports